<template>
  <ModalQuaternary/>
  <div class="buey_3d" v-show="mainStore.showBueyFull === true && mainStore.windowWidth>=960">
    <model-viewer
    id="buey_full"
    alt="Buey" 
    src="/models/buey.glb"
    ios-src="/models/buey.usdz"
    camera-target="0m .8m 0m"
    camera-orbit="0deg 60deg 5m"
    shadow-intensity="1"
    camera-controls touch-action="pan-y">
    </model-viewer>
  </div>
  <div class="modal_tertiary_full" v-show="mainStore.windowWidth>=960" style="background-image:url('/img/bg_buey.png');background-position: 50% 50%;background-repeat: no-repeat;background-size: cover;">
    <div class="container">
      <h1 class="return" @click="hideModal()">Volver a la finca</h1>
      <div class="container_in">
        <p class="description_full">Haz click en los puntos interactivos<br>para ver el despiece tradicional del buey</p>
        <div class="content" style="justify-content: center;">
          <div>
        <img src="/img/buey_full_new.png" usemap="#buey_full_map" alt="" >
        <map name="buey_full_map">
          <area target="" alt="lomo" title="lomo" href="#" @click="mapClick(2)" coords="187,178,19" shape="circle">
    <area target="" alt="tripa" title="tripa" href="#" @click="mapClick(1)" coords="173,277,20" shape="circle">
    <area target="" alt="pierna" title="pierna" href="#" @click="mapClick(0)" coords="68,210,20" shape="circle">
    <area target="" alt="cuello" title="cuello" href="#" @click="mapClick(3)" coords="319,205,20" shape="circle">
        </map>
        </div>

        
        <button class="button_circular_full" @click="changeViewFull()">Buey 3D</button>
      </div>
      </div>
    </div>
  </div>
  <div class="modal_tertiary" v-show="mainStore.windowWidth<960">
    <!--<div class="close" @click="hideModal()"></div>-->
    <span @click="hideModal()" class="close_test">
      {{
        mainStore.is3DActive ? 'Volver al despiece' : 'Volver a la finca'
    }}
    </span>
    <p class="description">Haz click en los puntos interactivos<br>para ver el despiece tradicional del buey</p>
    <div class="img_container" v-show="mainStore.is3DActive === false">
    <img src="/img/buey.png" usemap="#buey_map" alt="">
    <map name="buey_map">
      <area target="" @click="mapClick(0)" alt="pierna" title="pierna" href="#" coords="83,131,14" shape="circle">
      <area target="" @click="mapClick(1)" alt="tripa" title="tripa" href="#" coords="149,172,15" shape="circle">
      <area target="" @click="mapClick(2)" alt="lomo" title="lomo" href="#" coords="156,110,14" shape="circle">
      <area target="" @click="mapClick(3)" alt="cuello" title="cuello" href="#" coords="238,128,13" shape="circle">
    </map>
  </div>
    <model-viewer v-show="mainStore.is3DActive === true"
    alt="Buey" 
    src="/models/buey.glb"
    ios-src="/models/buey.usdz"
    ar ar-modes="webxr scene-viewer quick-look" 
    camera-target="0m 0m -0.2m"
    shadow-intensity="1"
    camera-controls touch-action="pan-y">
  <button id="ar_button"  slot="ar-button" style="background-color: transparent; border: 1px solid #BEA58B; position: absolute; bottom:0;left:50%; transform:translate(-50%,0);width: 90px;height: 40px;font-family: 'cervo';color:#fff;font-size:22px;padding-top: 5px;display: none;">
      Ver en AR
  </button>
    </model-viewer>
    <button class="button_circular" @click="changeView()">
      {{
        mainStore.is3DActive ? 'Ver en AR' : 'Buey 3D'
    }}
    </button>
     <!--<ModalSecondary/>-->
  </div>
</template>

<script>
import { modalHide, modalShow } from '@/helpers/animations';
import ModalQuaternary from '@/components/ModalQuaternary.vue';
import '@google/model-viewer';
import {useMainStore} from '@/stores/mainStore';



export default {
  name: 'ModalTertiary',
  components:{
    ModalQuaternary
},
setup(){
  const mainStore = useMainStore();
  return {mainStore}
},
data(){
  return {
    windowWidth: window.innerWidth
  }
},
mounted(){
  window.onresize = ()=>{
    this.mainStore.windowWidth = window.innerWidth;
    console.log(this.windowWidth);
  }
},
  methods:{
    hideModal: function(){
      if(this.mainStore.is3DActive === true || this.mainStore.showBueyFull === true){
        this.mainStore.is3DActive = false;
        this.mainStore.showBueyFull = false
      }else{
        modalHide(document.querySelector('.modal_tertiary'),'primary');
        modalHide(document.querySelector('.modal_tertiary_full'),'primary');
      }
    },
    mapClick: function(n){
      if(n===0){
        console.log('pierna');
        this.mainStore.currentCategory = 'pierna';
        modalShow(document.querySelector('.modal_quaternary'),'quaternary');
        modalShow(document.querySelector('.modal_quaternary_full'),'quaternary');
      }else if(n===1){
        console.log('falda');
        this.mainStore.currentCategory = 'falda';
        modalShow(document.querySelector('.modal_quaternary'),'quaternary');
        modalShow(document.querySelector('.modal_quaternary_full'),'quaternary');
      }else if(n===2){
        console.log('chuletero');
        this.mainStore.currentCategory = 'chuletero';
        modalShow(document.querySelector('.modal_quaternary'),'quaternary');
        modalShow(document.querySelector('.modal_quaternary_full'),'quaternary');
      }else if(n===3){
        console.log('delantero');
        this.mainStore.currentCategory = 'delantero';
        modalShow(document.querySelector('.modal_quaternary'),'quaternary');
        modalShow(document.querySelector('.modal_quaternary_full'),'quaternary');
      }
    },
    changeView: function(){
      if(this.mainStore.is3DActive === false){
        this.mainStore.is3DActive = true
      }else{
        document.getElementById('ar_button').click();
      }

    },

    changeViewFull: function(){
      this.mainStore.showBueyFull = true;

    }
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#buey_full{
  width: 100%;
  height:100%
}
.modal_tertiary_full{
  width: 100%;
  height: 100%;
  position: absolute;
  top:0;
  left:0;
  background-color:#fff;
  transform: scale(0);
  z-index: 10;
}

.content{
  display: flex;
  flex-direction: row;
}
.return{
  color:#fff;
  text-decoration: underline;
  font-family: 'garamond';
  font-size: 18px;
  font-weight: 400;
  transform: translateY(-10px);
}

.description_full{
  font-family: 'garamond';
  color: #BEA58B;
  text-align: center;
  font-size: 18px;
}

.button_circular_full{
  width: 128px;
  height: 128px;
  border-radius: 128px;
  background-color: #2A282C;
  color:#fff;
  font-family: 'cervo';
  font-size: 22px;
  border:8px solid rgba(212,211,212,.2);
  outline: 8px solid rgba(212,211,212,.1);
  animation: button 6s infinite;
  align-self: flex-end;
}

.container{
  background: rgba(0,0,0,.8);
  top:0;
  left: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}

.buey_3d{
  background: #2B282C;
  top:50%;
  left: 50%;
  transform:translate(-50%,-50%);
  position: absolute;
  width: 80%;
  height: 80%;
  display: flex;
  z-index: 11;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}

.container_in{
  background: #2B282C;
  width: 80%;
  height:80%;
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
  align-items: center;
}
  

model-viewer{
  width: 100%;
  height:300px;
  margin-top: 20px;
}
.img_container{
  width: 100%;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.modal_tertiary{
  position: absolute;
  z-index: 10;
  background-color: #2b282c;
  width:100%;
  height: 100%;
  left: 0;
  top:0;
  transform: scale(0);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap:5px;
  overflow: hidden;
}
.modal_tertiary > h1{
  font-family: 'cervo';
  margin-left: 15px;
  margin-bottom: 15px;
  color:#fff
}
.modal_tertiary > p{
  font-family: 'garamond';
  padding: 15px;
  margin-bottom: 15px;
  color:#fff;
  font-size: 18px;
}

.modal_tertiary > .description{
  font-family: 'garamond';
  color: #BEA58B;
  text-align: center;
  font-size: 16px;
  margin-top:45px
}

.close_test{
  color:#fff;
  font-family: 'garamond';
  text-decoration: underline;
  font-size:18px;
  align-self: center;
  margin: 15px;
  padding: 12px;/*correction*/
  z-index: 10;
}

@keyframes button {
  0% { outline: 8px solid rgba(212,211,212,.01); }
  25% { outline: 8px solid rgba(212,211,212,.05);}
  50% { outline: 8px solid rgba(212,211,212,.01);}
  75% { outline: 8px solid rgba(212,211,212,.05);}
  100% { outline: 8px solid rgba(212,211,212,.01); }
}

.button_circular{
  width: 96px;
  height: 96px;
  border-radius: 96px;
  background-color: #2A282C;
  color:#fff;
  font-family: 'cervo';
  font-size: 22px;
  border:8px solid rgba(212,211,212,.2);
  outline: 8px solid rgba(212,211,212,.1);
  animation: button 6s infinite;
}
</style>
